<template>
  <div id="project">

    <div class="o-modal">
      <div class="o-modal-content big">
        <div class="o-modal-header">
          <a
            @click="closeProject"
            class="close clickable"
          ><i class="fas fa-times"></i></a>
          <p class="lead">Portfolio Project</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <h2>{{ project.title }}</h2>
          <div class="row">
            <div class="col-md-6">
              <transition name="fade">
                <div
                  v-if="loading == true"
                  class="spinner d-flex justify-content-center"
                  style="padding-top:50px;"
                >
                  <b-spinner style="width: 5rem; height: 5rem;" label="Loading..."></b-spinner>
                </div>
              </transition>
              <b-carousel
                controls
                indicators
                id="carousel"
                img-width="1024"
                img-height="480"
                class="mb-2 min-height"
              >
                <b-carousel-slide
                  v-for="image in gallery"
                  v-bind:key="image.url"
                  :img-src="image.url"
                ></b-carousel-slide>
              </b-carousel>
              <b-btn
                v-if="project.development_nid"
                @click="getUnits(project.development_nid)"
              >
                Units Available
              </b-btn>
              <b-btn
                v-if="project.geo"
                :href="'https://www.google.com/maps/search/?api=1&query=' + project.geo"
                :target="'_blank'"
              >
                Location
              </b-btn>
              <hr>
              <p><small>Architect:</small><br>{{ project.architect }}</p>
              <p><small>Developer:</small><br>{{ project.developer }}</p>
            </div><!-- /.col-md-6 -->
            <div class="col-md-6">
              <div
                v-html="project.body"
              >
              </div>
            </div><!-- /.col-md-6 -->
          </div><!-- /.row -->
        </div><!-- /.o-modal-body -->
        <div v-if="showUnits" id="available-units">
          <transition name="fade">
            <div
              v-if="loading == true"
              class="spinner d-flex justify-content-center"
              style="padding-top:50px;"
            >
              <b-spinner style="width: 5rem; height: 5rem;" label="Loading..."></b-spinner>
            </div>
          </transition>
          <b-btn @click="showUnits = false" class="mb-2 btn-sm"><i class="fas fa-arrow-left"></i> Back to Project</b-btn>
          <div v-if="!units[0] && loading == false"><p>No units available at this time.</p></div>
          <div v-for="unit in units" class="card mb-4">
            <img class="card-img-top" :src="'https://buffalofts.com/' + unit.image" alt="Card image cap">
            <div class="card-body">
              <p class="lead"><span class="price">{{ unit.price }}</span></p>
              <h5 class="card-title">{{ unit.title }}</h5>
              <p class="lead"><i class="fas fa-ruler"></i> {{ unit.area }}&nbsp;&nbsp;&nbsp;<i class="fas fa-bed"></i> {{ unit.bedrooms }}&nbsp;&nbsp;&nbsp;<i class="fas fa-shower"></i> {{ unit.bathrooms }}</p>
              <a :href="unit.url" class="btn btn-primary float-right" target="_blank">View Unit <i class="fas fa-arrow-right"></i></a>
            </div>
          </div><!-- /.card -->
        </div><!-- /#available-units -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->

  </div><!-- /#project -->
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      gallery: [],
      showUnits: false,
      units: false
    }
  },
  props: [
    'project'
  ],
  created() {
    let timeStamp = new Date().getTime()
    let nid = this.project.nid
    axios.get('https://buffalofts.com/api/portfolio/gallery?nid=' + nid + '&timestamp=' + timeStamp).then(response => {
      console.log(response)
      this.gallery = response.data
      this.loading = false
    })
  },
  methods: {
    getUnits(nid) {
      this.loading = true
      this.units = false
      this.showUnits = true
      let timeStamp = new Date().getTime()
      axios.get('https://buffalofts.com/api/portfolio/units?nid=' + nid + '&timestamp=' + timeStamp).then(response => {
        console.log(response)
        this.units = response.data
        this.loading = false
      })
    },
    closeProject() {
      this.$emit('closeProject')
    }
  }
}
</script>

<style>
#project {
  position: relative;
}
.min-height {
  min-height: 200px;
}
h2 {
  font-size: 24px;
}
#available-units {
  position: absolute;
  top: 50px;
  bottom: 00px;
  background-color: #eee;
  left: 0px;
  right: 0px;
  padding: 20px 30%;
  z-index: 15;
  overflow: scroll;
}
.price {
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
  background-color: #333;
  color: #fff;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 2px;
  position: absolute;
  top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Project.vue